import React from "react";
import '../custom frames/frame-style.scss'

const SimpleFrame = ({style, title, contentMessage}) => {
    return (
        <div class = {style}>
            <div class = 'title-content'>{title}</div>
            <div class = 'message-content'>{contentMessage}</div>
        </div>
    );
}


export default SimpleFrame;